<script setup>
import Percentage from '@/components/shared/transform/Percentage.vue'
import {toRefs, computed} from 'vue'

// Props
const props = defineProps({
  progress: {
    type: Number,
    default: 0,
    validator: value => value >= 0 && value <= 1,
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
  showLabelFirst: {
    type: Boolean,
    default: false,
  },
})

//Refs
const {progress} = toRefs(props)
const width = computed(() => `${progress.value * 100}%`)
</script>

<template>
  <div
    :class="$style.container"
    role="progressbar"
    aria-label="Progress"
    :aria-valuenow="progress * 100"
  >
    <div
      :class="$style.bar"
      role="presentation"
    >
      <div
        :class="$style.fill"
        :style="{width}"
      />
    </div>
    <span
      v-if="showLabel"
      :class="{
        [$style.label]: true,
        [$style.first]: showLabelFirst,
      }"
      role="presentation"
    >
      <slot name="label">
        <Percentage :fraction="progress" />
      </slot>
    </span>
  </div>
</template>

<style module lang="scss">
.container {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
}
.bar, .fill {
  height: 7px;
  border-radius: 1rem;
}
.bar {
  width: 100%;
  background-color: var(--bg-interactive-element);
  overflow: hidden;
  order: 2;
}
.fill {
  transition: width .5s ease-in-out, margin-left .5s ease-in-out;
  background-color: var(--bg-primary-element);
  max-width: 100%;
  opacity: 0.8;
}
.label {
  font-size: var(--font-size-text-small);
  flex: 0 0 3rem;
  text-align: right;
  order: 3;
  &.first {
    order: 1;
  }
}
</style>
